export class Logger {
    constructor(props) {
        this._prefix = 'MAX';
        /** console日志 **/
        this._log = (type, msg, ...others) => {
            switch (type) {
                case 'INFO':
                    console.info(`[${this._prefix} ${type}]: ${msg}${others.length > 0 ? '\n' : ''}`, ...others);
                    break;
                case 'WARN':
                    console.warn(`[${this._prefix} ${type}]: ${msg}${others.length > 0 ? '\n' : ''}`, ...others);
                    break;
                case 'ERROR':
                    console.error(`[${this._prefix} ${type}]: ${msg}${others.length > 0 ? '\n' : ''}`, ...others);
                    break;
                default:
                    console.log(`[${this._prefix} ${type}]: ${msg}${others.length > 0 ? '\n' : ''}`, ...others);
                    break;
            }
        };
        this.log = (msg, ...others) => {
            if (globalThis?.__MAX_DEBUG__) {
                this._log('LOG', msg, ...others);
            }
        };
        this.info = (msg, ...others) => {
            this._log('INFO', msg, ...others);
        };
        this.warn = (msg, ...others) => {
            this._log('WARN', msg, ...others);
        };
        this.error = (msg, ...others) => {
            this._log('ERROR', msg, ...others);
        };
        this._prefix = props.prefix;
    }
}
